/**
 * @file handshakeActions.js
 * @location src/store/reducers/taskActions/handshakeActions.js
 * @role task 핸드셰이크 액션 — 읽음 수신(읽음)만. (검수 루프 폐기 razor ㉓)
 *
 *  ACK_TASK  담당-가 업무를 열면(열람) → acknowledgedAt 설정 (읽음 수신, 멱등). 별도 승인 버튼 없음
 *
 *  구 SUBMIT_FOR_REVIEW/APPROVE_TASK/REJECT_TASK/APPEND_TASK_UPDATE 는 razor ㉓ 로 폐기.
 *  완료는 lifecycle 의 TOGGLE_TASK(done↔todo)로만. 코멘트 채널(updates) 폐기.
 */
export const handshakeActions = {
  ACK_TASK: (state, action) => ({
    ...state,
    tasks: state.tasks.map(t =>
      t.id !== action.id || t.acknowledgedAt
        ? t
        : { ...t, acknowledgedAt: new Date().toISOString() }
    ),
  }),
};
